export default {
  en: {
    'pages.registrations-permissions.title.default': 'Registration Info',
    'pages.registrations.labels.day-due': 'Day due',
    'pages.registrations.labels.show-details': 'Show details',
    'pages.registrations.labels.hide-details': 'Hide details',
    'pages.registrations.labels.local-vat': 'Local VAT Number',
    'pages.registrations.labels.fiscale-code': 'Fiscale code',
    'pages.registrations.labels.submission-period': 'Submission period',
    'pages.registrations.labels.periodicity': 'Periodicity',
    'pages.registrations.labels.vat': 'VAT Number',
    'pages.registrations.labels.reg-date': 'Registration date',
    'pages.registrations.labels.de-registration-date': 'De-registration date',
    'pages.registrations.labels.filing-start-date': 'Filing start date',
    'pages.registrations.add.choose-a-country': 'Please select a country to continue',
    'pages.registrations.labels.filing-start-date-info':
      'This is the period ending date from which your first filing shall be generated in {product}.',
    'pages.registrations.errors.local-vat-error': 'Local VAT number is required',
    'pages.registrations-permissions.registrations-information.title': 'Registration Information',
    'pages.registrations.registration-info-create.notification.success':
      'Registration created successfully.',
    'pages.registrations.registration-info-create.notification.error':
      'Registration creation failed.',
    'pages.registrations.registration-info-update.notification.success':
      'Registration updated successfully.',
    'pages.registrations.registration-info-update.notification.error':
      'Registration update failed.',
    'pages.registrations.registration-info-delete.notification.success':
      'Registration deleted successfully.',
    'pages.registrations.registration-info-delete.notification.error':
      'Registration deletion failed.',
    'pages.registrations.filing-types-fetch.notification.error': 'Failed to fetch filing types.',
    'pages.registrations.filing-type-options-fetch.notification.error':
      'Failed to fetch filing type options.',
    'pages.registrations.filing-types-delete.notification.success':
      '{filingName} successfully deleted.',
    'pages.registrations.filing-types-delete.notification.error': 'Failed to delete {filingName}.',
    'pages.registrations.filing-types-create.notification.success':
      '{filingName} created successfully.',
    'pages.registrations.filing-types-create.notification.error': 'Failed to create {filingName}.',
    'pages.registrations.filing-types-update.notification.success':
      '{filingName} updated successfully.',
    'pages.registrations.filing-types-update.notification.error': 'Failed to update {filingName}.',
  },
};
